import classNames from "classnames";
import React from "react";
import { Amount } from "../Amount/Amount";
import styles from "./SegmentBar.module.scss";

interface SegmentDataProps {
    label: string;
    value: number;
    valueOverride?: string;
    subtitle?: React.ReactNode;
    formatValueAsMoney?: boolean;
    subtitleColor?: string;
    className?: string;
}

export const SegmentData: React.FC<SegmentDataProps> = ({
    label,
    value,
    valueOverride,
    subtitle,
    formatValueAsMoney,
    subtitleColor,
    className,
}) => (
    <div className={classNames(styles.segmentData, className)}>
        <span className={styles.label}>{label}</span>
        {formatValueAsMoney ? (
            <Amount
                amount={value}
                separateCurrencySign
                className={styles.value}
            />
        ) : (
            <span className={styles.value}>{valueOverride ?? value}</span>
        )}
        {subtitle && (
            <span
                className={styles.subtitle}
                style={subtitleColor ? { color: subtitleColor } : undefined}
            >
                {subtitle}
            </span>
        )}
    </div>
);
